import { render, staticRenderFns } from "./RevenuesTypeForm.vue?vue&type=template&id=717fc5b1&"
import script from "./RevenuesTypeForm.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports